import { isAxiosError } from "axios";
// import { ZodError } from "zod";

// Helper function to create the error structure
const createApiError = ({ code, message, type, data }) => ({
  code,
  message,
  type,
  data,
});

// Internal function for developer logging
const logError = ({ apiName, err, extraDetails }) => {
  console.log({ apiName, err });
  // In a real project, here you would integrate with Sentry, Bugsnag, etc.
  // console.error(`[API Error - ${apiName}]`, err, extraDetails);
};

// Function to map internal errors to user-friendly messages
const handleErrorMessages = (error) => {
  switch (error.type) {
    case "axiosError":
      if (error.code === 404) {
        return "The requested resource was not found.";
      }
      if (error.code >= 500) {
        return "There was a problem with the server. Please try again later.";
      }
      return "A communication error occurred. Try again.";
    case "validationError":
      return "The provided data is not valid.";
    case "metadataError":
      return "There was a problem with the system information.";
    default:
      return "An unexpected error has occurred.";
  }
};

export const handleApiError = (apiName, error, extraDetails) => {
  //   if (error instanceof ZodError) {
  //     const err = createApiError({
  //       code: "VALIDERR",
  //       message: "Validation Error",
  //       type: "validationError",
  //       data: error.issues, // Zod validation details
  //     });

  //     logError({ apiName, err, extraDetails });

  //     return { ...err, userMessage: handleErrorMessages(err) };
  //   }

  if (isAxiosError(error)) {
    // You can serialize the Axios error to save only what is necessary
    const serialized = {
      message: error.message,
      name: error.name,
      code: error.code,
      status: error.response?.status,
      data: error.response?.data,
      config: error.config,
      // ... other relevant properties
    };

    const err = createApiError({
      code: serialized.status || serialized.code,
      message: serialized.message ?? "Http error",
      type: "axiosError",
      data: serialized,
    });

    logError({ apiName, err, extraDetails });

    return { ...err, userMessage: handleErrorMessages(err) };
  }

  const err = createApiError({
    code: "GENERIC",
    message: "Generic Error",
    type: "genericError",
    data: String(error),
  });

  logError({ apiName, err, extraDetails });

  return { ...err, userMessage: handleErrorMessages(err) };
};
